<template>
  <v-card>
    <div id="toast" style="
        overflow: hidden;
        position: absolute;
        width: 600px;
        padding: 12px 24px;
        color: #ffffff;
        height: 42px;
        background: #0000;
        transition: 0.3s;
        z-index: 120;
      " />
      <v-col style="padding-top: 32px; overflow: hidden !important">
        <cam-image title="Biometrias Aluno" :randomGesture="choosedGesture" :momento="getMomento()" @onCapture="getImage" />
      </v-col>
  </v-card>
</template>

<script>
import { format } from "date-fns";
import axios from "axios";
import CamImage from "@/components/Util/Cam";
import aulasTeorica from "@/ws/aulasTeorica";
import biometriaPR from "@/ws/biometriaPR";
import biometriaMA from "@/ws/biometriaMA";
import Api from "@/service/Api";

export default {
  name: "ColetaBiometria",
  components: { CamImage },

  props: {
    tempObjMeet: {
      type: Object,
      required: true,
    },
    choosedGesture: {
      type: String,
      required: true,
    },
    momentoAtual: {
      type: Number,
      required: true,
    },
  },

  data() {
    return {
      toastMessage: null,
      momento: null,
      studentImage: null,
      processing: null,
      attemps: 0,
      momento: this.momentoAtual, 
    };
  },

  methods: {
    getImage(img) {
      this.studentImage = img;
      this.updateInfo();
    },
    async registrarAlertaTentativas(mensagem = null, idAlerta = 13) {
      try {
        const idAluno = this.$store.getters.getAluno.id;
        const idAula = this.tempObjMeet.id;
        const texto = mensagem;

        const res = await aulasTeorica.setAlertaMensagem(idAluno, idAula, texto, idAlerta);
        if (res && res.data && res.data.message) {
          console.log(res.data.message, true);
        }
      } catch (e) {
        console.error(e);
        this.toast("Erro ao registrar alerta no servidor.");
      }
    },

    updateInfo: async function () {
      this.attemps += 1;
      this.toast("Aguarde a validação da imagem.");
      var data = new FormData();

      data.append("file2", `${this.studentImage}`);

      data.append(
        "file1",
        `data:image/png;base64, ${this.$store.getters.getAluno.foto}`
      );

      var config = {
        method: "post",
        url: Api.defaults.baseURL + "/biometria",
        headers: Api.defaults.headers,
        data: data,
        attemps: 0,
        processing: false,
        tempObjMeet: null,
      };
      // refatoração
      if (this.attemps >= 5 && this.$store.getters.getCfc.uf != "PR") {
        alert("Limite de tentativas excedido. (5)");
        await this.registrarAlertaTentativas(`Biometria inválida, tentativa de captura número (${this.attemps}/5). Momento=${momento == 0? "Entrada":"Saída"}.`);
        this.attemps = 0;
    
        this.saveResult(true);
        setTimeout(() => {
          document.dispatchEvent(new CustomEvent("closeBio"));
        }, 0.8 * 1000);
      } else {
        try {
          if (this.$store.getters.getCfc.uf == "PR") {
            let response = await biometriaPR.facesCompare(
              this.$store.getters.getAluno.renach,
              this.$store.getters.getAluno.cpf,
              this.studentImage,
              this.$store.getters.getCfc.codigo
            );
            if (response.data.error) {
              this.toast(response.data.error);
              setTimeout(() => {
                if (confirm("Deseja continuar mesmo sem validação?") == true) {
                  this.saveResult(false);
                } else {
                  alert('Por favor, colete outra biometria.');
                  document.dispatchEvent(new CustomEvent("carregaInicio"));
                }
              }, 2000);
            } else {
              this.saveResult(true);
            }

          } else if (this.$store.getters.getCfc.uf == "MA") {
            let responseMA = await biometriaMA.biometriaValid(
              this.$store.getters.getAluno.renach,
              this.$store.getters.getAluno.cpf,
              this.studentImage,
              window.momento
            );
            if (window.momento == 1) {
              this.saveResult(false);
              return;
            }
            if (responseMA.data.error) {
              this.toast(responseMA.data.error);
            } else {
              let salvarHashMa = responseMA.data;

              var result = await aulasTeorica.salvarHashMa(
                this.tempObjMeet.id,
                salvarHashMa.cpf,
                salvarHashMa.hash,
                salvarHashMa.momento
              );
              if (result.data.error) {
                this.toast(result.data.error);
              } else {
                this.toast(result.data.message);
                this.saveResult(true, salvarHashMa.hash);
              }
            }
          } else {
            let response = await axios(config);
            if (response.data.erro) {
              this.toast(response.data.erro);
              if (this.$store.getters.getCfc.uf === "MT") {
                if (window.momento == 1) {
                  this.saveResult(true);
                } else if (this.attemps >= 5) {
                  this.saveResult(true);
                } else {
                  this.toast(`Tente novamente (${this.attemps}/5)`);
                  const momento = window.momento == 0 ? "Entrada" : "Saída";
                  await this.registrarAlertaTentativas(`Biometria inválida, tentativa de captura número (${this.attemps}/5). Momento=${momento}.`);
                }
              } else {
                this.saveResult(false);
              }
            } else {
              this.saveResult(true);
            }
          }
        } catch (error) {
          this.toast(
            "Não foi possível se conectar com o servidor, tente novamente."
          );
        }
      }
      // finalizar
      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("displayCam"));
      }, 1.5 * 1000);
    },

    async tooManyAttemps() {
      this.toast("Pessoa não autorizada. Limite de tentativas excedidas");
      this.live = null;
      this.tempObjMeet = null;
    },

    drawFace(data) {
      if (data.face) {
        let face = data.face;
        let box = document.getElementById("face");
        let image = document.getElementById("sentImage");

        box.style.height = face.Height * image.clientHeight + "px";
        box.style.width = face.Width * image.clientWidth + "px";

        box.style.top = face.Top * image.clientHeight + "px";
        box.style.left = face.Left * image.clientWidth + "px";

        this.toast("Biometria verificada com sucesso!", true);

        return true;
      } else {
        return false;
      }
    },

    drawEquipement(data) {
      if (data.equipement) {
        let equipement = data.equipement;
        let box = document.getElementById("equipement");
        let image = document.getElementById("sentImage");

        box.style.height = equipement.Height * image.clientHeight + "px";
        box.style.width = equipement.Width * image.clientWidth + "px";

        box.style.top = equipement.Top * image.clientHeight + "px";
        box.style.left = equipement.Left * image.clientWidth + "px";
        return true;
      } else {
        return false;
      }
    },

    async saveResult(validation = false, hash = "") {
      this.processing = false;

      const name = `${format(new Date(), "yyyyMMddHmm")}_${this.tempObjMeet.id
        }_${this.$store.getters.getAluno.renach}_fa.jpeg`; //-> "202011241526_1_999999999_fa.jpeg"

      if (window.momento === 0) {
        setTimeout(() => {
          this.attemps = 0;
          document.dispatchEvent(new CustomEvent("toLiveStream"));
        }, 0.2 * 1000);
      }

      await aulasTeorica.setCamImage(
        this.studentImage,
        name,
        this.tempObjMeet.id,
        this.$store.getters.getAluno.id,
        validation,
        this.choosedGesture,
        window.momento,
        hash
      );

      setTimeout(() => {
        document.dispatchEvent(new CustomEvent("closeBio"));
      }, 0.8 * 1000);
    },

    getMomento() {
      return window.momento;
    },

    toast(message, status = false) {
      let toast = document.getElementById("toast");
      if (status === true) {
        toast.style.backgroundColor = "#00dd90";
      } else {
        toast.style.backgroundColor = "#ff8a00";
      }
      toast.innerText = message;

      setTimeout(function () {
        toast.style.background = "#0000";
        toast.innerText = "";
      }, 8000);
    },
  },
};
</script>